var ServiceBanner = {};

//--------------
// Variables
//--------------



//--------------
// Functions
//--------------

/**
 * Init Service Banner
 * @return {void}
 */
ServiceBanner.initServiceBanner = function() {

  //-- Add loaded class
  window.onload = function(){
  	$('.js-service-banner').addClass('is-loaded');
  };
}

/**
 * Active Service
 * @return {void}
 */
ServiceBanner.activeService = function(element) {

  //-- class Active
  $('.js-service-banner-item').removeClass('is-active');
  element.addClass('is-active');
}


/**
 * Init Service Banner scripts
 * @return {[type]} [description]
 */
ServiceBanner.init = function() {
	ServiceBanner.initServiceBanner();

	//-- Active Service
	$('.js-service-banner-item').click(function(e){
		e.preventDefault();
		var $this = $(this);
		var parser = document.createElement('a');
		parser.href = $this.prop('href');

		ServiceBanner.activeService($this);
		Barba.request($(this).prop('href')).then(function(result){
			$('#service-detail').replaceWith($(result).find('#service-detail'));
			history.pushState(null, null, parser.pathname);

		  gtag('js', new Date());
		  gtag('config', 'UA-132206738-1', {
	      'anonymize_ip': true, // for GDPR
	      'page_title' : document.title,
	      'page_path': parser.pathname
	    });

			App.animationsController = new ScrollMagic.Controller();
			Animations.init();
			return false;
		});
		return false;
	});

}

/**
 * Destroy Service Banner scripts
 * @return {void}
 */
ServiceBanner.destroy = function() {

}

//--------------
// Execution
//--------------


module.exports = ServiceBanner;